/**
 * @fileoverview User lifecycle constants.
 * @description The one lifecycle reason code that behaves differently from the rest: OTHER, whose
 * note is required (the backend refuses it without one). Every other reason's note is optional.
 * Also the ids and test id prefixes of the Edit, Deactivate and Reactivate dialogs' forms.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** The reason that needs a note, for Deactivate and Reactivate User alike. */
export const OTHER_REASON_CODE = 'OTHER'

/** The longest a reason note may be, until GET /users/configuration says otherwise. */
export const DEFAULT_REASON_NOTE_MAX_LENGTH = 500

/** The id of the Deactivate dialog's form, so its footer button can submit it. */
export const DEACTIVATE_FORM_ID = 'deactivate-user-form'

/** The test id prefix of the Deactivate dialog. */
export const DEACTIVATE_TEST_ID = 'deactivate-user'

/** The id of the Reactivate dialog's form, so its footer button can submit it. */
export const REACTIVATE_FORM_ID = 'reactivate-user-form'

/** The test id prefix of the Reactivate dialog. */
export const REACTIVATE_TEST_ID = 'reactivate-user'

/** The id of the Edit dialog's form, so its footer button can submit it. */
export const EDIT_FORM_ID = 'edit-user-form'
